import React from "react";
import { Routes, Route } from "react-router-dom";
import TechAgency from "./TechAgency";
import TrackProject from "./TrackProject";
import AdminDashboard from "./AdminDashboard";
import WebDevelopmentService from "./WebDevService";
import MobileAppDevelopment from "./MobileAppDevelopment";
import CustomSoftwareDevelopment from "./CustomSoftwareDevelopment";
import APIBackendServices from "./APIandBackend";
import MaintenanceServices from "./Maintenance";
import AIServices from "./AIServices";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfService from "./TermsOfService";
import CookiePolicy from "./CookiePolicy";
import ScrollToTop from "./ScrollToTop";
import PageMotion from "./PageMotion";
import "./motion.css";

function App() {
  return (
    <>
      <ScrollToTop />
      <PageMotion />
      <Routes>
        <Route path="/" element={<TechAgency />} />
        <Route path="/track-project" element={<TrackProject />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/web-development" element={<WebDevelopmentService />} />
        <Route path="/mobile-app" element={<MobileAppDevelopment />} />
        <Route
          path="/custom-software"
          element={<CustomSoftwareDevelopment />}
        />
        <Route path="/api-backend" element={<APIBackendServices />} />
        <Route path="/maintenance" element={<MaintenanceServices />} />
        <Route path="/ai-services" element={<AIServices />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
      </Routes>
    </>
  );
}

export default App;
